/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type WidgetIconContainer_widget$ref: FragmentReference;
export type WidgetIconContainer_widget = {|
  +id: string,
  +type: ?string,
  +visible: ?boolean,
  +$refType: WidgetIconContainer_widget$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "WidgetIconContainer_widget",
  "type": "Widget",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "visible",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'bdfef46af212213efb1aef4c634d4a8a';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Widget/__generated__/WidgetIconContainer_widget.graphql.js